import Home from "./pages/Home.jsx";
import CaseDetail from "./pages/CaseDetail.jsx";
import ArticleDetail from "./pages/ArticleDetail.jsx";
import PreviewPage from "./pages/PreviewPage.jsx";
import NotFound from "./pages/NotFound.jsx";
import AllWorks from "./pages/AllWorks.jsx";
import AllCertifications from "./pages/AllCertifications.jsx";
import AllArticles from "./pages/AllArticles.jsx";
import { Route, Routes } from "react-router-dom";
import Navbar from "./components/Navbar/Navbar.jsx";
import Footer from "./components/Footer/Footer.jsx";
import { Analytics } from "@vercel/analytics/react";

function App() {
  return (
    <>
      <Navbar />
      <main style={{ flex: 1 }}>
        <Routes>
          <Route index element={<Home />} />
          <Route path="/work" element={<AllWorks />} />
          <Route path="/certifications" element={<AllCertifications />} />
          <Route path="/articles" element={<AllArticles />} />
          <Route path="/case/:id" element={<CaseDetail />} />
          <Route path="/article/:id" element={<ArticleDetail />} />
          <Route path="/preview" element={<PreviewPage />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </main>
      <Footer />
      <Analytics />
    </>
  );
}

export default App;
